import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const effortThemesService = {
  getThemes: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/themes/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching themes:", error);
      throw error;
    }
  },

  createTheme: async (effortId, themeData) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/themes/`,
        themeData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating theme:", error);
      throw error;
    }
  },

  deleteTheme: async (effortId, themeId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/themes/${themeId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting theme:", error);
      throw error;
    }
  },
};

export default effortThemesService;
